import React, { useEffect, useState, useRef, useContext } from 'react';
import { CommonModal, CustomPagination } from 'components';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { AddEditOwnDriver } from 'modals';
import { changeDriverStatusData, deleteOwnDriverData, getOwnDriverListData } from '_services/accountsServices/ownDriverServices';
import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import RupeeIcon from '../Supplier/RupeeIcon';
import LoadingBar from 'react-top-loading-bar';
import { UserContext } from 'context';
import { getDriverDropdownListData } from '_services/dropdownServices/dropdownService';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { constant } from 'constants/constant';

const OwnDriver = ({ showOffcanvas, toggleOffcanvas, listSearch }) => {
  useDocumentTitle("Own Driver | T360");
  const loadingBarRef = useRef(null);
  const { mastersChild, setMasterDetailsList } = useContext(UserContext);
  const masterChildDriver = mastersChild?.find((i) => i?.label === "Driver");
  const [ownDriverList, setOwnDriverList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    status: 1,
    driver_type: 1
  });

  const [checkboxStates, setCheckboxStates] = useState({});

  const getDataOwnDriverList = async () => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        ...filter,
        ...listSearch,
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
      }
      // const res = await getDriverDropdownListData(object);
      const res = await getOwnDriverListData(object);
      if (res?.responseCode == 200) {
        setOwnDriverList(res?.data?.driver_list);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete(); // Complete the loading bar
      }
    }
  }

  useEffect(() => {
    getDataOwnDriverList();
  }, [listSearch, filter, showOffcanvas])

  const deleteHandler = (item) => {
    setIsDelete(item);
  }

  const submitDeleteOwnDriver = async (e) => {
    e.preventDefault()
    setLoading(true);
    try {
      let object = {
        company_id: isDelete?.company_id,
        driver_id: isDelete?._id,
      }
      const res = await deleteOwnDriverData(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataOwnDriverList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.success('Error !! ');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteOwnDriver,
    isLoadding: loading,
  }

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Driver Name", accessor: "driver_name" },
    { header: "Firm", accessor: "firm_id" },
    { header: "Contact No.", accessor: "contact_nunber" },
    { header: "Licence No.", accessor: "licence_number" },
    { header: "Truck Associated", accessor: "truck_associated" },
    { header: "Balance", accessor: "balance" },
    { header: "Status", accessor: "status" },
    { Header: "Action", accessor: "action" }

  ];

  useEffect(() => {
    if (ownDriverList && ownDriverList.length > 0) {
      const initialStates = ownDriverList.reduce((acc, item) => {
        acc[item._id] = Boolean(item?.active);
        return acc;
      }, {});
      setCheckboxStates(initialStates);
    }
  }, [ownDriverList]);

  const handleCheckboxChange = (id) => {
    const newStatus = !checkboxStates[id];

    setCheckboxStates(prevStates => ({ ...prevStates, [id]: newStatus }));

    const object = {
      company_id: StorageService.getCompanyId(),
      driver_id: id,
      active: Number(newStatus)
    };
    statusChangeofOwnDriver(object);
  };

  const statusChangeofOwnDriver = async (obj) => {
    try {
      if (obj) {
        const res = await changeDriverStatusData(obj);
        if (res?.responseCode === 200) {
          toast.success(`${res?.responseMessage}`);
        } else {
          toast.error('Error !!');
          await getDataOwnDriverList()
        }
      }
    } catch (error) {
      toast.error(error.message);
      await getDataOwnDriverList()
    }
  };



  const editHandler = (data) => {
    toggleOffcanvas(data);
  };

  const RowListData = (data) => {

    return data?.map((item, i) => ({
      ...item,
      serial:
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              {masterChildDriver?.view === 1 && <Link to={`/account/driver/details/${item?._id}`} className='_avPointer'
                style={{ textDecoration: 'none' }}
              >
                <span className='_samAnchor'>
                  <span className='viewIcon_avt'>
                    <AiOutlineEye />
                  </span>View
                </span>
              </Link>}

              {masterChildDriver?.edit === 1 && <div
                onClick={(e) => editHandler(item)}
                className='_avPointer'
              >
                <span className='_samAnchor'>
                  <span className='editIcon_avt'>
                    <FiEdit />
                  </span>
                  Edit
                </span>
              </div>}

              {/* {masterChildDriver?.delete === 1 && <div
                onClick={(e) => deleteHandler(item)}
                className='_avPointer'
              >
                <span className='_samAnchor'>
                  <span className='deleteIcon_avt'>
                    <FaRegTrashCan color='red' />
                  </span>
                  Delete
                </span>
              </div>} */}
            </div>
          </div>

        </React.Fragment>,
      driver_name:
        // <Link to={`details/${item?._id}?type=${constant.m_type.driver}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`} style={{ textDecoration: 'none' }} onClick={() => setMasterDetailsList((s) => ({ ...s, list: ownDriverList, details: item }))} state={{ data: { driver: "own", type: 1, name: item?.name } }}>
        //   {item?.name ? item?.name : '-'}
        // </Link>,
        <Link to={`/account/driver/details/${item?._id}`} style={{ textDecoration: 'none' }} state={{ data: { driver: "own", type: 1, name: item?.name } }}>
          {item?.name ? item?.name : '-'}
        </Link>,
      firm_id: <React.Fragment>
        {item?.firm_id?.firm ? item?.firm_id?.firm : '-'}
      </React.Fragment>,
      contact_nunber:
        <React.Fragment>
          {item?.contact_no ? item?.contact_no : '-'}
        </React.Fragment>,
      licence_number:
        <React.Fragment>
          {item?.licence_number ? item?.licence_number : '-'}
        </React.Fragment>,
      truck_associated:
        <React.Fragment>
          -
        </React.Fragment>,
      balance: item?.balance ? (
        <Link to={`/account/driver/details/${item?._id}`} style={{ textDecoration: 'none' }} state={{ data: { driver: "own", type: 2, name: item?.name } }}>
          <div style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            color: Number(item.balance) < 0 ? '#dc3545' : Number(item.balance) > 0 ? '#28a745' : '#1450ec'
          }}>
            <span>
              <RupeeIcon
                color={item.balance < 0 ? '#dc3545' : item.balance > 0 ? '#28a745' : '#1450ec'}
                size={20}
              />
            </span>
            <span>
              {item?.balance ? Math?.abs(item?.balance)?.toFixed(2) : 0}
            </span>
          </div >
        </Link >

      ) : (
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          color: '#1450ec'
        }}>
          <span>
            <RupeeIcon
              color='#1450ec'
              size={20}
            />
          </span>
          <span>
            0
          </span>
        </div>
      ),
      status: (
        <div className="_anvSwitcherNew form-check form-switch" style={{ width: "125px" }}>
          <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            autoComplete="off"
            checked={checkboxStates[item._id]}
            onChange={() => handleCheckboxChange(item._id)}
          />
          <span className={checkboxStates[item._id] ? "active_label_masters_status" : "disabled_label_masters_status"}>
            {checkboxStates[item._id] ? "Active" : "Disabled"}
          </span>
        </div>
      ),
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          {masterChildDriver?.view === 1 && <Link to={`/account/driver/details/${item?._id}`} className='_avPointer' state={{ data: { driver: "own", type: 1, name: item?.name } }}
            style={{ textDecoration: 'none' }}
          >
            <span className='_samAnchor'>
              <span className='viewIcon_avt'>
                <AiOutlineEye color='green' />
              </span>
            </span>
          </Link>}

          {masterChildDriver?.edit === 1 && <div
            onClick={(e) => editHandler(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>

            </span>
          </div>}

          {/* {masterChildDriver?.delete === 1 && <div
                onClick={(e) => deleteHandler(item)}
                className='_avPointer'
              >
                <span className='_samAnchor'>
                  <span className='deleteIcon_avt'>
                    <FaRegTrashCan color='red' />
                  </span>
                  
                </span>
              </div>} */}
        </div>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
  };

  return (
    <div>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />
      <div className='_tabWith_topTab'>
        <BootstrapTable
          columns={columns}
          data={RowListData(ownDriverList?.length > 0 ? ownDriverList : [])}
          isLoading={loading}
        />
        {ownDriverList?.length > 0 ? <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div> : <></>}
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvas ? 'visible' : 'hidden' }}
      >
        {showOffcanvas &&
          <AddEditOwnDriver isOpen={showOffcanvas} onClose={toggleOffcanvas} />
        }
      </div>

      <div className={showOffcanvas ? 'offBack_drop' : ''}></div>

      {isDelete?._id && (
        <CommonModal {...propsObject}>
          <p className='p-3'> Are you sure you want to delete {isDelete?.name} ? </p>
        </CommonModal>
      )}
    </div>
  );
}

export default OwnDriver;
